<template>
  <div class="objection">
    <div style="float: right;" class="margin-bottom-10">
      <el-input class="padding-right-12" v-model="userPhone" placeholder="用户手机号码" style="width:200px" @keyup.enter.native="handleSearch"></el-input>
      <el-select class="padding-right-12" v-model="replyStatus" placeholder="回复状态" style="width:150px" clearable>
        <!-- <el-option label="全部" value="-1"></el-option>
        <el-option label="未验证" value="0"></el-option>
        <el-option label="已验证" value="1"></el-option> -->
        <el-option
            v-for="item in replyStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-select v-model="Stype" placeholder="反馈类型" style="width: 260px" auto-complete="off" clearable>
          <el-option v-for="item in StypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>

      <el-button slot="append" icon="el-icon-search" type="primary" @keyup.enter="handleSearch" @click="handleSearch" style="margin-left:10px;">搜索</el-button>
    </div>
    <el-table
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      stripe
      border
      :data="tableData"
      style="width: 100%;z-index:999;"
      height="500">
        <el-table-column
          prop="s_id"
          label="序号"
          sortable
          align="center"
          min-width="80"
          >
       </el-table-column>
       <el-table-column
          prop="s_status"
          label="处理状态"
          sortable
          align="center"
          min-width="120"
          >
       </el-table-column>
       <el-table-column
          prop="user_phone"
          label="反馈用户手机号码"
          sortable
          align="center"
          min-width="160"
          >
       </el-table-column>
      <el-table-column
          prop="s_createtime"
          label="反馈时间"
          sortable
          align="center"
          min-width="160"
          >
       </el-table-column>
       <el-table-column
          prop="reply_name"
          label="回复人"
          sortable
          align="center"
          min-width="100"
          >
       </el-table-column>
       <el-table-column
          prop="s_replytime"
          label="回复时间"
          sortable
          align="center"
          min-width="160"
          >
       </el-table-column>
      <!-- <el-table-column prop="s_img" label="图片" sortable align="center" min-width="200">
        <template slot-scope="scope">
          <img
            v-for="item in scope.row.s_img"
            :src="imgUrl + item"
            height="34px"
            class="showImg"
            @click="showImg(scope.row)">
        </template>
      </el-table-column> -->

       <el-table-column
          prop="s_type"
          label="类型"
          sortable
          align="center"
          min-width="100"
          >
       </el-table-column>
       <el-table-column
          prop="s_contact"
          label="联系方式"
          sortable
          align="center"
          min-width="120"
          >
       </el-table-column>
       <!-- <el-table-column
          prop="s_content"
          label="内容"
          sortable
          align="center"
          >
       </el-table-column> -->
       <el-table-column
          label="操作"
          align="center"
          fixed="right"
          min-width="100"
          >
          <template slot-scope="scope">
              <router-link :to="'/suggestion/objection/objectionReply/'+scope.row.s_id">
                <el-button type="text" size="small" style="margin-right:10px">回复</el-button>
              </router-link>
              <router-link :to="'/suggestion/objection/objectionDetail/'+scope.row.s_id">
                <el-button type="text" size="small" style="margin-right:10px">查看</el-button>
              </router-link>
              <!-- <el-button @click="contentReply(scope.row)" type="text" size="small">回复</el-button> -->
              <!-- <el-button @click="handleDetail(scope.row)" type="text" size="small">查看</el-button> -->
              <!-- <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button> -->
          </template>
       </el-table-column>  
    </el-table>

    <!-- 分页 -->
    <div id="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="limit"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!-- 查看详情的模态框 -->
    <!-- <el-dialog
      v-elDragDialog
      :visible.sync="DetailDialogTableVisible"
      title="意见管理详情" 
      @closed="cancleDetailForm('DetailForm')"
      :close-on-click-modal="false">
      表单
      <el-form ref="DetailForm" :model="DetailForm" label-width="80px" style="width:100%;">
        <el-form-item label="序号">
          <el-input v-model="DetailForm.s_id" disabled></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio v-model="DetailForm.s_status" disabled label="0">未处理</el-radio>
          <el-radio v-model="DetailForm.s_status" disabled label="1">已处理</el-radio>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="DetailForm.user_phone" disabled></el-input>
        </el-form-item>
        <el-form-item label="反馈时间">
          <el-input v-model="DetailForm.s_createtime" disabled></el-input>
        </el-form-item>
        <el-form-item label="回复人">
          <el-input v-model="DetailForm.reply_name" disabled></el-input>
        </el-form-item>
        <el-form-item label="回复时间">
          <el-input v-model="DetailForm.s_replytime" disabled></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="s_img">
            <el-upload
                disabled
                :class="{disabled:uploadDisabled}"
                :limit="1"
                :action="DetailUploadUrl"
                list-type="picture-card"
                :on-preview="handleDetailPreview"
                :file-list="DetailUploadFileList">
                <i class="el-icon-plus"></i>
            </el-upload>
        </el-form-item>
        <el-form-item label="类型">
          <el-input v-model="DetailForm.s_type" disabled></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="DetailForm.s_contact" disabled></el-input>
        </el-form-item>
        <el-form-item label="内容">
          <el-input v-model="DetailForm.s_content" disabled></el-input>
        </el-form-item>
      </el-form>
    </el-dialog> -->



    <!-- 回复内容模态框 -->
    <!-- <el-dialog
      v-elDragDialog
      :visible.sync="ReplyDialogTableVisible"
      title="回复内容" 
      @closed="cancleReplyForm('ReplyForm')"
      :close-on-click-modal="false">
      表单
      <el-form ref="ReplyForm" :model="ReplyForm" label-width="80px" style="width:100%;">
        <el-form-item label="序号">
          <el-input v-model="ReplyForm.s_id" disabled></el-input>
        </el-form-item>
        <el-form-item label="回复内容">
          <el-input type="textarea" v-model="ReplyForm.s_reply"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submitReplyForm('ReplyForm')">提交</el-button>
            <el-button @click="cancleReplyForm('ReplyForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog> -->


    <!-- 列表放大图片 -->
    <!-- <el-dialog 
      :visible.sync="ImgDialog"
      :title="'序号'+currentImg.s_id" 
      width="40%"
      :close-on-click-modal="false">
      <img v-for="item in currentImg.s_img" :src="imgUrl + item" width="100%">
    </el-dialog> -->



    <!-- 详情放大图片 -->
    <!-- <el-dialog :visible.sync="DetailPreviewDialogVisible">
        <img width="100%" :src="DetailPreviewDialogImageUrl" alt="">
    </el-dialog> -->


  </div>
</template>

<script>
// 引入接口
import api from '@/api/api.js'
// 获取token
import { getToken , removeToken } from '@/utils/auth'
// 引用拖拽
import elDragDialog from '@/directive/el-dragDialog';
// 时间过滤器
import {formatDate} from '@/filter/date.js';

export default {
  name: 'objection',
  directives : {elDragDialog} ,
  data() {
      return {
          loading : true, //加载条
          tableData : [],
          total: 0, // 分页总条数
          start: 0, // 默认第一页
          limit: 10,  // 每页10条

          userPhone: '', //用户手机号码
          replyStatus:null,//回复状态
          Stype:null,//反馈类型

          replyStatusOptions : [ //回复状态列表
              {
                  value: '0',
                  label: '未处理'
              },
              {
                  value: '1',
                  label: '已处理'
              },
          ],
          
          StypeList : [], //反馈类型列表

          searchData: {
              name1: '',
              id2: '',
              id1: '',
          },


          imgUrl : `${api.address}`,
          ImgDialog : false,
          currentImg: '',

          // 查看详情的数据
          /*DetailForm : {
            s_id : '',
            s_status : '',
            user_phone : '',
            s_createtime: '',
            reply_name : '',
            s_replytime : '',
            s_img :'',
            s_type: '',
            s_contact:'',
            s_content : '',
          },
          DetailUploadUrl : `${api.dev}/p/suggestion/objection/uploadFile?access_token=${getToken()}`, // 上传图片路径
          DetailUploadFileList : [],
          DetailPreviewDialogVisible : false,
          DetailPreviewDialogImageUrl : '',
          DetailDialogTableVisible : false,*/ // 详情框默认的模态框






          /*ReplyForm:{
            s_id:'',
            s_reply:'',
          },
          ReplyDialogTableVisible : false, */// 回复框默认的模态框

      }
  },
  methods : {
    handleSearch(){
      this.searchData = {
        name1: this.userPhone,
        id2: this.replyStatus,
        id1: this.Stype,
      }
      this.getInfo();
    },
    getLimit(){
      this.$http.post(
        `${api.dev}/p/main/preference/show`,
        {
          access_token: getToken(),
        },
        {emulateJSON : true}
      ).then(res => {
        if(res.body.code == 200) {
          this.limit = (res.body.content) ? res.body.content.p_pagesize : 10;
          this.getInfo();
        }else if(res.body.code == 500) {
          this.$message({
            message: res.body.msg,
            type: 'error'
          });
          this.getInfo();
        }else if(res.body.code == 510) {
          this.$message({
            message: res.body.msg,
            type: 'error'
          });
          removeToken();
          setTimeout(function () {
            this.$router.push({path: '/login'})
          },2000)
        }
      })
    },
    getInfo() {

        //获取反馈类型列表
        this.$http.get(`${api.dev}/p/main/drop/selectSuggestion`,{params:{access_token : getToken() , start : this.start, limit : this.limit}}).then(res => {
          if(res.body.code == 200) {
            this.StypeList = res.body.content;
          }else if(res.body.code == 500) {
            this.$message({
              message : res.body.msg,
              type : 'error'
            })
            removeToken();
            setTimeout(function () {
              this.$router.push({path: '/login'});
            },2000)
          }
        })


      this.$http.get(`${api.dev}/p/main/suggestion/show`,{params:{
          access_token : getToken() , 
          start : this.start, 
          limit : this.limit,
          name1 : this.searchData.name1,
          id2 : this.searchData.id2,
          id1 : this.searchData.id1,
      }}).then(res => {
        if(res.body.code == 200) {
          res.body.content.records.forEach( i => {
            /*if(i.s_status == 0) {
              i.s_status = '未处理'
            }else if(i.s_status == 1) {
              i.s_status = '已处理'
            }*/
            if(i.s_createtime != null){
                i.s_createtime = formatDate(new Date(i.s_createtime),'yyyy-MM-dd hh:mm:ss');
            }
            if(i.s_replytime != null){
                i.s_replytime = formatDate(new Date(i.s_replytime),'yyyy-MM-dd hh:mm:ss');
            }
          })
          this.tableData = res.body.content.records;
          this.total = res.body.content.total;
          this.loading = false;
        }else if(res.body.code == 500) {
          this.$message({
            message : res.body.msg,
            type : 'error'
          })
          removeToken();
          setTimeout(function () {
            this.$router.push({path: '/login'});
          },2000)
        }
      })


    },
    /* 大图查看 */
    showImg(row){
      this.ImgDialog = true;
      this.currentImg = row;
      console.log(this.currentImg);
    },
    // 处理详情操作
    /*handleDetail(row) {
          // 开启加载器
          const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
          });
          this.$http.get(`${api.dev}/p/main/suggestion/select`,{params : {access_token : getToken(), s_id : row.s_id}}).then(res => {
            if(res.body.code == 200) {
              loading.close();
              this.DetailDialogTableVisible = true;

              this.DetailForm = res.body.content;

              this.DetailForm.s_id = res.body.content.s_id;

              if(res.body.content.s_status == false){
                res.body.content.s_status = '0';
              }else if(res.body.content.s_status == true){
                res.body.content.s_status = '1';
              }
              // this.DetailForm.s_status = (res.body.content.s_status).toString();
              this.DetailForm.s_status = res.body.content.s_status;
              this.DetailForm.user_phone = res.body.content.user_phone;
              this.DetailForm.s_createtime = formatDate(new Date(res.body.content.s_createtime),'yyyy-MM-dd hh:mm:ss');
              if(this.DetailForm.s_img.length > 0){
                for(var i=0;i<this.DetailForm.s_img.length;i++){
                  this.DetailUploadFileList.push({url : `${api.address}${this.DetailForm.s_img[i]}`})
                }
              }
              this.DetailForm.reply_name = res.body.content.reply_name;
              // this.DetailForm.s_replytime = res.body.content.s_replytime;
              this.DetailForm.s_replytime = formatDate(new Date(res.body.content.s_replytime),'yyyy-MM-dd hh:mm:ss');

              if(res.body.content.s_type == "1"){
                res.body.content.s_type = "稿文申诉";
              }else if(res.body.content.s_type == "2"){
                res.body.content.s_type = "作品申诉";
              }else if(res.body.content.s_type == "3"){
                res.body.content.s_type = "意见建议";
              }else if(res.body.content.s_type == "4"){
                res.body.content.s_type = "文章纠错";
              }else if(res.body.content.s_type == "5"){
                res.body.content.s_type = "内容纠错";
              }
              this.DetailForm.s_type = res.body.content.s_type;
          
              this.DetailForm.s_contact = res.body.content.s_contact;
              this.DetailForm.s_content = res.body.content.s_content;

            }else if(res.body.code == 500) {
              this.$message({
                message: res.body.msg,
                type: 'error'
              });
              removeToken();
              setTimeout(function () {
                this.$router.push({path: '/login'});
              },2000)
            }
          })
    },*/

    // 取消查看
    /*cancleDetailForm(formName) {
      this.DetailDialogTableVisible = false;
      this.DetailUploadFileList = [];
    },*/

    // 放大图片
    /*handleDetailPreview(file) {
        this.DetailPreviewDialogVisible = true;
        this.DetailPreviewDialogImageUrl = file.url;
    },*/



    //回复内容
    /*contentReply(row){
         this.ReplyForm.s_id = row.s_id;
         this.ReplyDialogTableVisible = true; 
    },*/

    // 取消回复内容模态框
    /*cancleReplyForm(formName) {
      this.ReplyDialogTableVisible = false;
    },*/

    // 处理删除操作
    // handleDelete(row) {
    //   this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //   }).then(() => {
    //     this.loading = true;
    //     this.$http.post(`${api.dev}/p/main/suggestion/delete`,{access_token : getToken(), s_id : row.s_id},{emulateJSON : true}).then(res => {
    //       if(res.body.code == 200) {
    //         this.$message({
    //             message: '删除成功',
    //             type: 'success'
    //         });
    //         if(this.start == this.total - 1){
    //           this.start = this.start - this.limit;
    //           if(this.start < 0){
    //             this.start = 0;
    //           }
    //         }
    //         this.getInfo();
    //       }else if(res.body.code == 500) {
    //         this.$message({
    //             message : res.body.msg,
    //             type : 'error'
    //         })
    //         removeToken();
    //         setTimeout(function () {
    //           this.$router.push({path: '/login'});
    //         },2000)
    //       }
    //     })
    //   })
    // },


    /*submitReplyForm(formName){
      this.$refs[formName].validate((valid) => {
        if(valid) {
            // 开启加载器
            const loading = this.$loading({
                lock: true,
                text: '正在保存中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            var formdata = new FormData();
            formdata.append('access_token',getToken());
            formdata.append('s_id',this.ReplyForm.s_id);
            formdata.append('s_reply',this.ReplyForm.s_reply);
            this.$http.post(`${api.dev}/p/main/suggestion/reply`,formdata,{emulateJSON: true}).then(res => {
              if(res.body.code == 200) {
                    loading.close();
                    this.ReplyDialogTableVisible = false;
                    this.$refs[formName].clearValidate(); // 清除表单验证规则
                    this.$message({
                        message: res.body.msg,
                        type: 'success'
                    });
                    this.loading = true;
                    this.getInfo();
              }else if(res.body.code == 500) {
                loading.close();
                this.$message({
                    message : res.body.msg,
                    type : 'error'
                })
              }
            })
        }else {
          console.log('error submit');
          return false;
        }
      })
    },*/


    /* 分页 */
    handleCurrentChange(val) {
      this.loading = true;
      this.start = this.limit * (val - 1);
      this.getInfo();
    }
  },
  created() {
    this.getInfo();
    this.getLimit();
  },
  computed: {
      /*uploadDisabled:function() {
          return this.DetailForm.s_img != '' && this.DetailForm.s_img != null
      },*/
  },
}
</script>

<style lang="stylus" scoped>
.margin-bottom-10
  margin-bottom 10px
.padding-right-12
  padding-right 12px
.showImg{
  vertical-align middle
}
.showImg:hover{
  cursor zoom-in
}
.objection{
  .el-table .cell img.showImg{
    padding:0 5px;
  }
}
</style>
